import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { environment } from '../../../../environment/environment';
import { restEndPoints } from '../../../app.constants';
import {
  IStripeFeeResponse,
  IStripeLogResponse,
  IStripeLogs,
  IStripeResponse,
  IStripeTransactionRequest,
  IStripeTransactionResponse,
} from './transaction.interface';

// Define an interface for the transaction data for better type safety
interface Transaction {
  transactionDate: string;
  importDate: string | null;
  client: string;
  serviceProvider: string;
  amount: string;
  taskId: string;
  invoiceNumber: string;
  transactionType: string;
  transactionId: string;
  importStatus: string;
}

interface TransactionsResponse {
  items: Transaction[];
  totalCount: number;
}

@Injectable({
  providedIn: 'root',
})
export class TransactionsService {
  apiHost = environment.apiHost; // Replace with your API host
  endPoints = restEndPoints.accounting;
  // Dummy data for demonstration
  private dummyTransactions: Transaction[] = Array.from(
    { length: 100 },
    (_, i) => ({
      transactionDate: `2024-07-${(i % 30) + 1 < 10 ? '0' : ''}${(i % 30) + 1}`,
      importDate:
        i % 5 === 0
          ? null
          : `2024-07-${(i % 30) + 1 < 10 ? '0' : ''}${(i % 30) + 1}`,
      client: `Johnny Nguyen ${i + 1}`,
      serviceProvider: `Klusup ${i + 1}`,
      amount: `€${(100 + i).toFixed(2)}`,
      taskId: `16959${i}`,
      invoiceNumber: `OGI 22558-${252253 + i}`,
      transactionType: i % 3 === 0 ? 'Payment' : 'Transfer',
      transactionId: `txn_1BCbUPIZZMWNTppNKS5vfmJvR${i}`,
      importStatus:
        i % 4 === 0
          ? 'Failed'
          : i % 4 === 1
            ? 'Imported'
            : i % 4 === 2
              ? 'Open'
              : 'Payment',
    }),
  );

  constructor(private _http: HttpClient) {}

  // getTransactions(page: number, pageSize: number, sortColumn: string, sortDirection: string): Observable<any> {
  //   const url = `/api/transactions?page=${page}&pageSize=${pageSize}&sortBy=${sortColumn}&sortDir=${sortDirection}`;
  //   return this.http.get(url);
  // }

  getTransactionLogsById(
    transactionId: string,
  ): Observable<any> {
    // Simulate fetching logs for a specific transaction ID
    const url = `${this.apiHost}${this.endPoints[0].stripe.getStripeLogsById}?stripeTransId=${transactionId}`;
    return this._http.get<IStripeLogs>(url);
  }

  getStripeFeeData(
    body: IStripeTransactionRequest,
  ): Observable<IStripeFeeResponse> {
    // Simulate fetching Stripe fee data
    const url = `${this.apiHost}${this.endPoints[0].stripe.getStripeFeeData}`;
    return this._http.post<IStripeFeeResponse>(url, body);
  }

  getStripeData(
    body: IStripeTransactionRequest,
  ): Observable<IStripeTransactionResponse> {
    // Simulate fetching Stripe data
    const url = `${this.apiHost}${this.endPoints[0].stripe.getStripeData}`;
    return this._http.post<IStripeTransactionResponse>(url, body);
  }
}
